export default __webpack_public_path__ + "static/media/MVI.bf34b72b.webp";